export default {
  loadingScheme: 'Loading scheme',
  partNoPlaceholder: 'Enter Part No',
  noAssetQualificationsMatch: 'Part "{part}" cannot be processed on furnace "{asset}".',
  noMatchedRecipeFound: 'Part "{part}" cannot be processed on furnace "{asset}" and recipe "{recipe}".',
  amountDoesNotMatch: 'Maximum number for part "{part}" is exceeded. "{max}" parts are allowed to be loaded, but "{actual}" parts were loaded.',
  totalWeight: 'Total weight',
};
